interface QueryParamDict {
  [key: string]: any;
}

export function stringifyQueryParams(params: QueryParamDict): string {
  return Object.entries(params)
    .map(([key, value]) => `${key}=${value.toString()}`)
    .join('&');
}

export function appendGetParams(url: string, params: QueryParamDict): string {
  const [path, hash] = url.split('#');
  const separator = path.includes('?') ? '&' : '?';
  const hashString = hash ? `#${hash}` : '';
  return `${path}${separator}${stringifyQueryParams(params)}${hashString}`;
}

export function getParamsObject(paramStr = window.location.search): QueryParamDict {
  const getparamsArray = paramStr.replace('?', '').split('&');
  const getparams: QueryParamDict = {};

  getparamsArray.forEach(param => {
    if (param.length > 0) {
      const [key, value]: string[] = param.split('=');
      getparams[key] = value;
    }
  });

  return getparams;
}

const FROM_CLASSROOM_QUERY_STRING = 'fromClassroomId=';

export function appendClassroomIdToUrl(absoluteUrl: string, classroomId?: number): string {
  return classroomId
    ? `${absoluteUrl}?${FROM_CLASSROOM_QUERY_STRING}${encodeURIComponent(classroomId)}`
    : absoluteUrl;
}

export const cleanLlpQueryParam = (llp?: string | Array<string | null>): string | null => {
  if (!llp) {
    return null;
  }
  if (typeof llp === 'string') {
    return llp;
  }
  return llp[0] ?? null;
};

export const maybeAppendFromLLP = ({
  baseUrl,
  learningPathSlug,
}: {
  baseUrl: string;
  learningPathSlug: string | null;
}): string => {
  return appendExistentParams(baseUrl, { from_llp: learningPathSlug });
};

export const appendExistentParams = (baseUrl: string, params: QueryParamDict): string => {
  const existentParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== undefined && value !== null),
  );
  return appendGetParams(baseUrl, existentParams);
};

export const courseUrl = ({
  courseSlug,
  learningPathSlug,
  justCompletedLessonSlug,
}: {
  courseSlug: string;
  learningPathSlug?: string | null;
  justCompletedLessonSlug?: string | null;
}) => {
  return appendExistentParams(`/courses/${courseSlug}`, {
    from_llp: learningPathSlug,
    just_completed: justCompletedLessonSlug,
  });
};
